import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function allergyValidator(allergyDetailsControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const withAllergy = control?.value;
    const details = allergyDetailsControl?.value;

    if (withAllergy && (!details || details.trim() === '')) {
      return { allergyDetailsMissing: true };
    }

    return null;
  };
}
